export const reduceKeyString = (keyString, leadingLength = 10, endingLength = 8) => {

    let slicedKeyString = keyString.substring(0, leadingLength) + "..." + keyString.substring(keyString.length - endingLength, keyString.length);

    return slicedKeyString;
}